import type { LogEntry } from '@/types/log-entry';

/**
 * Returns true when the given log entries span at least two distinct calendar
 * years. This is the minimum data requirement to offer a year-over-year
 * scouting comparison.
 */
export function hasMultiYearScoutingData(entries: LogEntry[]): boolean {
  if (entries.length < 2) return false;
  const years = new Set(entries.map((e) => e.date.slice(0, 4)));
  return years.size >= 2;
}
